<template>
  <span>
    <span v-if="locations.length > 1">
      one of
    </span>

    <v-select multiple v-if="!readonly"
      class="d-inline-block select-field-no-child-input mx-2" required dense hide-details
      :style="locations.length === 0 ? 'transform: translate(0, -5px)' : ''"
      append-icon="" text="text" value="value" height="14px" style="min-width: 36px;"
      v-model="locations"
      :items="allLocations"
      @change="onQueryChange"/>
    <span v-else>{{allLocations.filter(i => locations.indexOf(i.value) > -1).map(i => i.text).join(' or ')}} </span>
  </span>
</template>

<script>
import {toTitleCase} from "@/helpers/TextUtils";

export default {
  name: "HasVisited",
  props: {
    onQueryChange: {
      type: Function,
      required: true,
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      locations: [],
    }
  },
  computed: {
    allLocations() {
      return [
        {text: 'their Home', value: 'home'}
      ].concat(this.$store.getters.poiSets.map(p => (
        {text: 'a ' + (p.display_name || toTitleCase(p.name)), value: p.name}
      )));
    },
    poiLocations() {
      return this.locations.filter(l => l !== 'home');
    },
    onDeviceLocations() {
      return this.locations.filter(l => l === 'home');
    }
  },
  created() {
    this.onChangeInitialConfig();
  },
  methods: {
    onChangeInitialConfig() {
      const initialLocations = this.initialConfig.locations;
      if (initialLocations) {
        if (initialLocations.pois) this.locations = this.locations.concat(initialLocations.pois);
        if (initialLocations.on_device) this.locations = this.locations.concat(initialLocations.on_device);
      }
      this.locations = this.locations
          .filter(v => this.allLocations.findIndex(l => l.value === v) >= 0);
    },
    getQuery() {
      let locations = {cluster_types: ["vanilla"]};
      if (this.poiLocations.length > 0) locations.pois = this.poiLocations;
      if (this.onDeviceLocations.length > 0) locations.on_device = this.onDeviceLocations;
      return {
        locations,
      }
    }
  },
  watch: {
    initialConfig() {
      this.onChangeInitialConfig();
    },
  }
}
</script>

<style scoped>

</style>